import { useEffect } from "react";

interface ToastProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

export default function Toast({ message, visible, onClose }: ToastProps) {
  useEffect(() => {
    if (!visible) return;
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 animate-soft-in">
      <div className="flex items-center gap-2 rounded-md border border-background-700 bg-background-900/95 px-4 py-2.5 text-sm text-foreground-900 backdrop-blur">
        <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
        <span>{message}</span>
      </div>
    </div>
  );
}